

















import VueOptions from '@utils/VueOptions'

settings =
  name: 'SuperNotes'
  vue:
    props: ['item']

    data: ->
      super_note: null

    methods:
      hiAddSuperNote: ->
        return if !@super_note.length
        @item.new_super_notes.push @super_note
        @super_note = ''
        @$emit 'change'

      hiRemoveNewNote: (noteIndex) ->
        @item.new_super_notes = @item.new_super_notes.filter((item, index) -> index != noteIndex)
        @$emit 'change'

export default VueOptions.vue settings
